module.exports = __webpack_public_path__ + "static/media/night_flight_cover.ba02c508.jpg";